export const LOGIN_TIME = 'loginTime';
export const LOGIN_FLOW = 'loginFlow';
export const LOGIN_SUCCESS = 'loginSuccess';
